// extracted by mini-css-extract-plugin
export default {"tpcCourseAssociate":"TopicCourseAssociationsModal_tpcCourseAssociate__e4iiz","txt":"TopicCourseAssociationsModal_txt__wkvFn"};